<script>
    export default {
        name: "datalist",
        data(){
            return {
                "date": {
                    "banner": {
                        "list": [
                            {
                                "pcUrl": "https://www.d1ev.com/news/zhanhui/72240",
                                "imgPath": "https://cdn-fs.d1ev.com/d/file/custom/30013/image/201807/1531371517245746.jpg!640x360",
                                "title": "发现汽车“第二性”！2018未来汽车开发者大会盛大开幕",
                                "summary": "7月12日，由GNEV官方机构主办、第一电动网承办的2018未来汽车展暨未来汽车开发者大会将在上海嘉定汽车会展中心盛大开幕"
                            },
                            {
                                "pcUrl": "https://www.d1ev.com/news/zhanhui/72184",
                                "imgPath": "https://cdn-fs.d1ev.com/d/file/custom/30092/image/201807/1531361150737978.jpg!640x360",
                                "title": "2018未来汽车展暨未来汽车开发者大会盛大开幕",
                                "summary": "7月12日，一年一度的新能源汽车盛会——未来汽车展暨未来汽车开发者大会（GNEVEXPO)，于上海嘉定汽车会展中心盛大开幕。"
                            },
                            {
                                "pcUrl": "https://www.d1ev.com/news/zhanhui/72287",
                                "imgPath": "https://cdn-fs.d1ev.com/d/file/custom/30013/image/201807/1531454533705702.jpg!640x360",
                                "title": "共享出行大咖汇聚珠峰南北坡——2018未来出行论坛",
                                "summary": "7月13日，由GNEV官方机构主办、第一电动网承办的2018未来汽车展暨未来汽车开发者大会“珠峰南北坡——未来出行论坛”在上海嘉定汽车会展中心举行。"
                            },
                            {
                                "pcUrl": "https://www.d1ev.com/news/pinglun/72292",
                                "imgPath": "https://cdn-fs.d1ev.com/d/file/custom/30013/image/201807/1531462936182850.jpg!640x360",
                                "title": "大咖热议分时租赁和网约车谁先有机会登顶珠峰",
                                "summary": "来自共享出行、汽车制造的大咖们共同探讨了登上珠峰的路径，旨在推动未来出行的模式创新和产业合作。"
                            }
                        ]
                    },
                    "recommendNews": {
                        "list": [
                            {
                                "pcUrl": "https://www.d1ev.com/news/renwu/72235",
                                "imgPath": "",
                                "title": "蔚来联合创始人秦力洪：ES8开始交付用户，蔚来完整走过第一轮，但这是一个开始",
                                "summary": "蔚来汽车联合创始人秦力洪在以“汽车的未来”主题演讲中表示，不像世界杯的热闹，如今扎堆出现的中国新创企业都有机会参与电动汽车的热闹，电动汽车的热闹一定属于中国，属于中国企业。"
                            },
                            {
                                "pcUrl": "https://www.d1ev.com/carnews/xinche/72277",
                                "imgPath": "",
                                "title": "长安汽车携逸动PHEV、CS75 PHEV、CS15 EV360亮相2018未来汽车展",
                                "summary": "在2018未来汽车展上，长安汽车为我们带来了逸动PHEV、CS75 PHEV、CS15 EV360共3款新能源车。"
                            },
                            {
                                "pcUrl": "https://www.d1ev.com/carnews/yongche/72255",
                                "imgPath": "",
                                "title": "与未来共起舞 北汽新能源携多款新车亮相2018未来车汽展",
                                "summary": "北汽新能源携旗下3款车型共同亮相，为今年的未来汽车展带来了精彩的亮点，同时展现了北汽新能源在造车技术领域的强大实力。"
                            }
                        ]
                    },
                    "newCar": {
                        "list": [
                            {
                                "id": 72231,
                                "title": "安亭镇长董爱华：安亭要做世界级汽车产业核心承载区",
                                "coverImgUrl": "https://cdn-fs.d1ev.com/d/file/custom/163579/image/201807/1531363970897261.jpg!216x144",
                                "summary": "嘉定区安亭镇党委副书记、镇长董爱华在开幕论坛上表示，安亭为在汽车产业发展作出了许多贡献，聚集了一大批汽车研发类、汽车整车厂，未来安亭将建立以汽车和全产业链布局为依托、面向未来的综合性产业社区——安亭·环同济创智城，打造世界级的汽车产业核心承载区。",
                                "tags": "",
                                "addTimeStr": "2018-07-12 08",
                                "pcUrl": ""
                            },
                            {
                                "id": 72233,
                                "title": "荣文伟：上海国际汽车城要建立世界第一的电动汽车示范区",
                                "coverImgUrl": "https://cdn-fs.d1ev.com/d/file/custom/152697/image/201807/1531366866163421.jpg!216x144",
                                "summary": "上海国际汽车城(集团)有限公司党委书记、董事长荣文伟发表主题演讲称上海国际汽车城已经成为中国第一个集研发、制造、文化、贸易、体育为一体的电动汽车国际示范城市基地。 ",
                                "tags": "",
                                "addTimeStr": "2018-07-12 08",
                                "pcUrl": "https://www.d1ev.com/news/renwu/72233"
                            },
                            {
                                "id": 72235,
                                "title": "蔚来联合创始人秦力洪：ES8开始交付用户，蔚来完整走过第一轮，但这是一个开始",
                                "coverImgUrl": "https://cdn-fs.d1ev.com/d/file/custom/30018/image/201807/1531366297464409.jpg!216x144",
                                "summary": "蔚来汽车联合创始人秦力洪在以“汽车的未来”主题演讲中表示，不像世界杯的热闹，如今扎堆出现的中国新创企业都有机会参与电动汽车的热闹，电动汽车的热闹一定属于中国，属于中国企业。",
                                "tags": "",
                                "addTimeStr": "2018-07-12 08",
                                "pcUrl": "https://www.d1ev.com/news/renwu/72235"
                            },
                            {
                                "id": 72238,
                                "title": "小鹏汽车夏衍：AI与汽车结合有巨大市场机会",
                                "coverImgUrl": "https://cdn-fs.d1ev.com/d/file/custom/152697/image/201807/1531372361944132.jpg!216x144",
                                "summary": "小鹏汽车联合创始人夏珩发表主题演讲，称电动汽车结合AI及互联网，将是中国新汽车时代巨大机会，而AI赋能的小鹏汽车致力于造年轻人喜欢的智能驾驶汽车。",
                                "tags": "",
                                "addTimeStr": "2018-07-12 08",
                                "pcUrl": "https://www.d1ev.com/news/renwu/72238"
                            },
                            {
                                "id": 72237,
                                "title": "沈海寅：硬件软件双轮驱动，奇点汽车正在不断成长稳步升级",
                                "coverImgUrl": "https://cdn-fs.d1ev.com/d/file/custom/30013/image/201807/1531369375674168.jpg!216x144",
                                "summary": "奇点汽车联合创始人沈海寅表示，奇点汽车希望打造的不仅仅是一个交通工具，而更是一款懂你的轮式机器人，这是奇点的初心。硬件软件双轮驱动，奇点汽车正在不断成长稳步升级。",
                                "tags": "",
                                "addTimeStr": "2018-07-12 08",
                                "pcUrl": "https://www.d1ev.com/news/renwu/72237"
                            },
                            {
                                "id": 72239,
                                "title": "谷峰：爱驰汽车明年9月份正式交车",
                                "coverImgUrl": "https://cdn-fs.d1ev.com/d/file/custom/30018/image/201807/1531371004389710.jpg!216x144",
                                "summary": "爱驰汽车联合创始人谷峰发表演讲时表示，爱驰汽车立志“重新定义车联网”，不是简单的汽车和互联网的相加，而是重新定义在车载使用场景下全新的用户体验；专注于改变出行方式，用智能化实现汽车的人性化，让出行不再成为负担，让出行成为乐趣。",
                                "tags": "",
                                "addTimeStr": "2018-07-12 08",
                                "pcUrl": "https://www.d1ev.com/news/renwu/72239"
                            },
                            {
                                "id": 72242,
                                "title": "Roadstar.ai那小川：未来出行服务车辆需满足三个条件",
                                "coverImgUrl": "https://cdn-fs.d1ev.com/d/file/custom/30018/image/201807/1531371999898936.jpg!216x144",
                                "summary": "Roadstar.ai首席战略官那小川在以“连接无人驾驶的未来与现在”的主题演讲中表示，未来出行服务车辆要满足三个条件：实现无人驾驶的基础功能；有最好的用户体验；成本。",
                                "tags": "",
                                "addTimeStr": "2018-07-12 08",
                                "pcUrl": "https://www.d1ev.com/news/renwu/72242"
                            },
                            {
                                "id": 72241,
                                "title": " 云度新能源常务副总林密：电动汽车要走进平民",
                                "coverImgUrl": "https://cdn-fs.d1ev.com/d/file/custom/163579/image/201807/1531371605119845.jpg!216x144",
                                "summary": "云度新能源联合创始人林密发表主题演讲称，电动汽车目前处于传统平台到兼容平台的过渡期，未来要做全新的电气化平台，走进平民。",
                                "tags": "",
                                "addTimeStr": "2018-07-12 08",
                                "pcUrl": "https://www.d1ev.com/news/renwu/72241"
                            },
                            {
                                "id": 72243,
                                "title": "威马汽车合伙人、CTO闫枫：威马要做智能电动汽车普及者",
                                "coverImgUrl": "https://cdn-fs.d1ev.com/d/file/custom/30018/image/201807/1531374425707937.jpg!216x144",
                                "summary": "威马汽车合伙人、CTO闫枫发表主题演讲称，中国汽车市场正在加速迎来“智能化、电动化、自动化、共享化”的产业变革。未来2-3年的时间会是汽车被重新定义的关键时期。我们正处在人工智能的技术奇点的前夜，在AI的赋能下，未来汽车智能化的“加速度”会越来越快，已经达到汽车产业出现重大转变的关键时期。",
                                "tags": "",
                                "addTimeStr": "2018-07-12 08",
                                "pcUrl": "https://www.d1ev.com/news/renwu/72243"
                            }
                        ]
                    },
                    "person": {
                        "list": [
                            {
                                "id": 72244,
                                "title": "未来开发者计划优秀项目 | 一微王国平：同城新能源货运网约车",
                                "coverImgUrl": "https://cdn-fs.d1ev.com/d/file/custom/163577/image/201807/1531378902353015.jpg!216x144",
                                "summary": "王国平认为他们项目的亮点是定位差异化，主要体现在新能源汽车、快消品和B2B三个方面；最后在谈到盈利模式时，王国平介绍了该项目盈利的主要来源为车辆租金、车体广告、维修和保险返利、电池残值回收、地方补贴、运营和充电桩补贴等方面。",
                                "tags": "",
                                "addTimeStr": "2018-07-12 08",
                                "pcUrl": "https://www.d1ev.com/news/zhanhui/72244"
                            },
                            {
                                "id": 72246,
                                "title": "未来汽车开发者计划优秀项目 | 戴世智能陆海峰：自动驾驶关键——车用惯性导航系统",
                                "coverImgUrl": "https://cdn-fs.d1ev.com/d/file/custom/152697/image/201807/1531381129806400.jpg!216x144",
                                "summary": "陆海峰在路演上介绍了戴世智能致力于研究RTK载波相位差分与惯性测量的技术的原理和在自动驾驶领域的应用。戴世智能的组合导航系统可在卫星质量差，甚至完全没有卫星信号的条件下在一定时间内保持米级的定位精度，为自动驾驶保驾护航。",
                                "tags": "",
                                "addTimeStr": "2018-07-12 08",
                                "pcUrl": "https://www.d1ev.com/news/jishu/72246"
                            },
                            {
                                "id": 72247,
                                "title": "未来汽车开发者计划优秀项目| XEV副总骆宾闻：量产3D打印微车",
                                "coverImgUrl": "https://cdn-fs.d1ev.com/d/file/custom/163579/image/201807/1531382920604157.jpg!216x144",
                                "summary": "骆宾闻在路演中着重讲解了项目的核心——3D打印技术。这种技术把材料从几十种缩减到了几种，打印的尺寸也为整车零部件打印重新优化，速度数倍于传统的通用3D打印机，实现了产品的快速迭代。",
                                "tags": "",
                                "addTimeStr": "2018-07-12 08",
                                "pcUrl": "https://www.d1ev.com/news/zhanhui/72247"
                            },
                            {
                                "id": 72248,
                                "title": "未来汽车开发者计划优秀项目 | 净相科技程镜江：导热和相变材料在电池热管理中应用",
                                "coverImgUrl": "https://cdn-fs.d1ev.com/d/file/custom/30018/image/201807/1531383166268720.jpg!216x144",
                                "summary": "净相科技的相变材料在热管理中的核心作用有以下几点作用1、降低高温放电或充电时的最高温度；2、提高电芯内部和电芯间的温度均一性；3、减少配套主动散热系统的复杂程度，简化热管理系统，降低总体成本；4、最大化保证动力系统能量密度；5、延缓外界环境温度变化对于电芯的影响；6、降低热失控的风险。",
                                "tags": "",
                                "addTimeStr": "2018-07-12 08",
                                "pcUrl": "https://www.d1ev.com/news/zhanhui/72248"
                            },
                            {
                                "id": 72249,
                                "title": "未来汽车开发者计划优秀项目 | 智充科技丁锐：打造垂直充电解决方案",
                                "coverImgUrl": "https://cdn-fs.d1ev.com/d/file/custom/152697/image/201807/1531383611962319.jpg!216x144",
                                "summary": "丁锐在路演上介绍了公司的商业模式，具体分为四大类功能：第一类是商户的部桩，几乎一天内可以完成安装。第二类是用户的管桩。第三类是用户找桩这是C端。第四类是用户用桩。",
                                "tags": "",
                                "addTimeStr": "2018-07-12 08",
                                "pcUrl": "https://www.d1ev.com/news/jishu/72249"
                            },
                            {
                                "id": 72253,
                                "title": "未来汽车开发者计划优秀项目 | 周艳玲：斑马快跑模式是巡游出租车+网约出租车",
                                "coverImgUrl": "https://cdn-fs.d1ev.com/d/file/custom/30018/image/201807/1531387408173845.jpg!216x144",
                                "summary": "在路演上周艳玲介绍了斑马快跑的商业模式：巡游出租车+网约出租车的模式，即用目前出租车的存量运力带动增量运力的发展模式。",
                                "tags": "",
                                "addTimeStr": "2018-07-12 08",
                                "pcUrl": "https://www.d1ev.com/news/zhanhui/72253"
                            }
                        ]
                    },
                    "video": {
                        "list": [
                            {
                                "id": 72281,
                                "title": "合众新能源副总黄招根：未来出行不仅有硬件，还包括软件+服务",
                                "coverImgUrl": "https://cdn-fs.d1ev.com/d/file/custom/152697/image/201807/1531448671156439.jpg!216x144",
                                "summary": "合众新能源副总裁黄招根表示，7月26日，合众将发布公司战略和新车，并将展示下一代概念车及在智能出行领域的技术储备。",
                                "tags": "",
                                "addTimeStr": "2018-07-13 08",
                                "pcUrl": "https://www.d1ev.com/news/qiye/72281"
                            },
                            {
                                "id": 72231,
                                "title": "环球车享总经理曹光宇：技术创新、运营服务、资源整合是分时租赁成功三要素",
                                "coverImgUrl": "https://cdn-fs.d1ev.com/d/file/custom/152697/image/201807/1531451222179163.jpg!216x144",
                                "summary": "环球车享总经理曹光宇表示，共享化是汽车行业发展的新趋势，未来共享出行市场将得到快速发展，其中分时租赁代表了共享出行新的发展方向，潜力十分巨大。",
                                "tags": "",
                                "addTimeStr": "2018-07-13 08",
                                "pcUrl": "https://www.d1ev.com/news/qiye/72284"
                            },
                            {
                                "id": 72285,
                                "title": "长安新能源冯中伟：长安将提供多元化分时租赁系统和生态圈服务",
                                "coverImgUrl": "https://cdn-fs.d1ev.com/d/file/custom/163579/image/201807/1531451898168820.jpg!216x144",
                                "summary": "长安新能源汽车事业部营销部副总经理冯中伟发表主题演讲称，未来长安将提供多元化分时租赁系统和生态圈服务。",
                                "tags": "",
                                "addTimeStr": "2018-07-13 08",
                                "pcUrl": "https://www.d1ev.com/news/zhanhui/72285"
                            },
                            {
                                "id": 72286,
                                "title": "嘀嗒出行CEO宋中杰：赋能巡游出租车移动技术出行特性",
                                "coverImgUrl": "https://cdn-fs.d1ev.com/d/file/custom/30018/image/201807/1531452564646218.jpg!216x144",
                                "summary": "嘀嗒出行CEO宋中杰介绍，嘀嗒通过为出租车公司定制开发信息化IT管理系统，将平台中出租车业务相关的信息数据全部开放给出租车公司，让行业运营数据化、可视化，让出租车公司管理更高效。",
                                "tags": "",
                                "addTimeStr": "2018-07-13 08",
                                "pcUrl": "https://www.d1ev.com/news/qiye/72286"
                            },
                            {
                                "id": 72288,
                                "title": "GoFun出行联合创始人袁旬：共享汽车应从单边模式向多边方向发展",
                                "coverImgUrl": "https://cdn-fs.d1ev.com/d/file/custom/30018/image/201807/1531455808711911.jpg!216x144",
                                "summary": "GoFun出行联合创始人兼高级副总裁袁旬发表演讲时表示，GoFun要做专业高效的车辆线下线上运营管理公司，共享汽车走到当下，应该从单边模式慢慢向多边方向发展。",
                                "tags": "",
                                "addTimeStr": "2018-07-13 08",
                                "pcUrl": "https://www.d1ev.com/news/qiye/72288"
                            }
                        ]
                    },
                    "technology": {
                        "list": [
                            {
                                "id": 72277,
                                "title": "长安汽车携逸动PHEV、CS75 PHEV、CS15 EV360亮相2018未来汽车展",
                                "coverImgUrl": "https://cdn-fs.d1ev.com/d/file/custom/31757/image/201807/1531443484909124.jpg!216x144",
                                "summary": "在未来汽车展上，长安汽车为我们带来了逸动PHEV、CS75 PHEV、CS15 EV360共3款新能源车，下面我就一起来看看吧。",
                                "tags": "",
                                "addTimeStr": "2018-07-13 08",
                                "pcUrl": "https://www.d1ev.com/carnews/xinche/72277"
                            },
                            {
                                "id": 72231,
                                "title": "云度π1、π3亮相2018未来汽车展",
                                "coverImgUrl": "https://cdn-fs.d1ev.com/d/file/custom/31757/image/201807/1531399760851621.jpg!216x144",
                                "summary": "云度新能源为大家带来了π1和π3两款展车，除此之外，在试驾区域还可对π1进行试乘试驾体验，让我们一起来了解一下吧。",
                                "tags": "",
                                "addTimeStr": "2018-07-13 08",
                                "pcUrl": "https://www.d1ev.com/carnews/xinche/72258"
                            },
                            {
                                "id": 72231,
                                "title": "上汽大通、吉利远程等多款新能源物流车亮相2018未来汽车展",
                                "coverImgUrl": "https://cdn-fs.d1ev.com/d/file/custom/30092/image/201807/1531401279630042.jpg!216x144",
                                "summary": "上汽大通、山东凯马、成功汽车、瑞驰新能源、吉利远程、上海捷泰、吉利远程、南京金龙等亮相2018未来汽车展。",
                                "tags": "",
                                "addTimeStr": "2018-07-13 08",
                                "pcUrl": "https://www.d1ev.com/carnews/yongche/72257"
                            },
                            {
                                "id": 72255,
                                "title": "与未来共起舞 北汽新能源携多款新车亮相2018未来车汽展",
                                "coverImgUrl": "https://cdn-fs.d1ev.com/d/file/custom/35817/image/201807/1531392498552876.jpg!216x144",
                                "summary": "北汽新能源携旗下3款车型共同亮相，为今年的未来汽车展带来了精彩的亮点，同时展现了北汽新能源在造车技术领域的强大实力。",
                                "tags": "",
                                "addTimeStr": "2018-07-13 08",
                                "pcUrl": "https://www.d1ev.com/carnews/yongche/72255"
                            },
                            {
                                "id": 72231,
                                "title": "助力绿色发展 吉利新能源四款新车亮相2018未来汽车展",
                                "coverImgUrl": "https://cdn-fs.d1ev.com/d/file/custom/35817/image/201807/1531398061832400.jpg!216x144",
                                "summary": "吉利新能源携旗下博瑞GE、帝豪EV、帝豪PHEV、帝豪GSe、四款车型共同亮相展会。",
                                "tags": "",
                                "addTimeStr": "2018-07-13 08",
                                "pcUrl": "https://www.d1ev.com/carnews/yongche/72254"
                            }
                        ]
                    },
                    "parter": {
                        "list1": [
                            {
                                "coverImgUrl": require("../../static/logo/media-01.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-02.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-03.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-04.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-05.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-06.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-07.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-08.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-09.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-10.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-11.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-12.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-13.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-14.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-15.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-16.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-17.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-18.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-19.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-20.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-21.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-22.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-23.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-24.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-25.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-26.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-27.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-28.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-29.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-30.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-31.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-32.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-33.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-34.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-35.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-36.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-37.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-38.png"),
                                "type": "media"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/media-39.png"),
                                "type": "media"
                            }
                        ],
                        "list2":[
                            {
                                "coverImgUrl": require("../../static/logo/parter-01.png"),
                                "type": "parter"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/parter-02.png"),
                                "type": "parter"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/parter-03.png"),
                                "type": "parter"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/parter-04.png"),
                                "type": "parter"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/parter-05.png"),
                                "type": "parter"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/parter-06.png"),
                                "type": "parter"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/parter-07.png"),
                                "type": "parter"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/parter-08.png"),
                                "type": "parter"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/parter-09.png"),
                                "type": "parter"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/parter-10.png"),
                                "type": "parter"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/parter-11.png"),
                                "type": "parter"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/parter-12.png"),
                                "type": "parter"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/parter-13.png"),
                                "type": "parter"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/parter-14.png"),
                                "type": "parter"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/parter-15.png"),
                                "type": "parter"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/parter-16.png"),
                                "type": "parter"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/parter-17.png"),
                                "type": "parter"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/parter-18.png"),
                                "type": "parter"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/parter-19.png"),
                                "type": "parter"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/parter-20.png"),
                                "type": "parter"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/parter-21.png"),
                                "type": "parter"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/parter-22.png"),
                                "type": "parter"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/parter-23.png"),
                                "type": "parter"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/parter-24.png"),
                                "type": "parter"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/parter-25.png"),
                                "type": "parter"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/parter-26.png"),
                                "type": "parter"
                            }
                        ],
                        "list3":[
                            {
                                "coverImgUrl": require("../../static/logo/zhichi-1.png"),
                                "type": "zhichi"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/zhichi-2.png"),
                                "type": "zhichi"
                            },
                            {
                                "coverImgUrl": require("../../static/logo/zhichi-3.png"),
                                "type": "zhichi"
                            }
                        ],
                        "list4":[
                            {
                                "coverImgUrl": require("../../static/logo/d1ev.png"),
                                "type": "chengban"
                            }
                        ],
                        "list5":[
                            {
                                "coverImgUrl": require("../../static/logo/qichecheng.png"),
                                "type": "xieban"
                            }
                        ]
                    },
                    "example": {
                        "list": [
                            {
                                "id": 72231,
                                "title": "",
                                "coverImgUrl": " ",
                                "summary": "",
                                "tags": "",
                                "addTimeStr": "2018-07-12 08",
                                "pcUrl": ""
                            },
                            {
                                "id": 72231,
                                "title": "",
                                "coverImgUrl": " ",
                                "summary": "",
                                "tags": "",
                                "addTimeStr": "2018-07-12 08",
                                "pcUrl": ""
                            }
                        ]
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/datalist.vue